"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _Stepper = _interopRequireDefault(require("@mui/material/Stepper"));
var _excluded = ["className", "noPadding", "light"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var styles = {
  "stepperWrapper": "DfCwEV",
  "noPadding": "lP2wJ1",
  "light": "nmHC50",
  "MuiAvatar-circle": "_9qO2u3",
  "noEndConnector": "YuV-vf"
};
var getClassName = function getClassName(_ref) {
  var className = _ref.className,
    noPadding = _ref.noPadding,
    light = _ref.light;
  return (0, _clsx["default"])(className, styles.stepperWrapper, noPadding && styles.noPadding, light && styles.light);
};
var StepperWrapper = function StepperWrapper(_ref2) {
  var className = _ref2.className,
    noPadding = _ref2.noPadding,
    light = _ref2.light,
    props = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Stepper["default"], _extends({
    className: getClassName({
      className: className,
      noPadding: noPadding,
      light: light
    })
  }, props));
};
StepperWrapper.propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes["default"].string,
  noPadding: _propTypes["default"].bool,
  light: _propTypes["default"].bool
} : {};
var _default = exports["default"] = StepperWrapper;